import Button from 'modules/shared-components/button/button';
import classNames from 'classnames';

interface TabProps {
  active: boolean;
  tabName: string;
  onClick: () => void;
}

export function Tab({ active, tabName, onClick }: TabProps) {
  return (
    <Button
      type="button"
      className={classNames(
        'xxs:py-4 border-none font-normal xxs:mr-2 lg:mr-8',
        active
          ? 'text-blue-500'
          : 'text-black-900 dark:text-white-50 hover:text-black-700 dark:hover:text-white-500'
      )}
      onClick={onClick}
    >
      {tabName}
    </Button>
  );
}
